export default __webpack_public_path__ + "static/media/giide-illo-09.17caf7cb.png";